import AppHeader from '../AppHeader'

export default {
  name: 'question-edit',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      questions: [
        {content: '', displayOrder: 1}
      ],
      canValidate: true,
      isSearchEnd: false,
      savingFlag: false
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,

        not_input: !!this.title
      }
      v.content = []
      v.content_all = true
      for (let index in this.questions) {
        let vc = (this.questions[index].content) ? true : false
        v.content.push(vc)
        v.content_all &= vc
      }
      v.not_input = v.not_input && !!v.content.length && !!v.content_all

      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title.title
        this.questions = res.question_details
        this.isSearchEnd = true
      })
      .catch(err => console.log(err))
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.questions = this.questions.map((question, index) => {
        question.displayOrder = index + 1
        return question
      })
      this.$store.dispatch('QUESTION_UPDATE', {
        id: this.$route.params.id,
        data: {
          title: this.title,
          contents: this.questions
        }
      })
      .then(res => {
        this.$router.push({path: '/question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/question')
    },
    addContent: function (index) {
      let question = {content: null, displayOrder: index + 2}
      this.questions.splice(index + 1, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/question-edit.js